import * as React from "react";
import Svg, { Path, Rect, Defs, LinearGradient, Stop } from "react-native-svg";
const ContactSyncIcon = (props) => (
  <Svg
    width={120}
    height={120}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M30 36C30 32.6863 32.6863 30 36 30H40C41.1046 30 42 30.8954 42 32C42 33.1046 41.1046 34 40 34H36.2857C35.0233 34 34 35.0233 34 36.2857V40C34 41.1046 33.1046 42 32 42C30.8954 42 30 41.1046 30 40V36Z"
      fill="#242424"
    />
    <Path
      d="M90 36C90 32.6863 87.3137 30 84 30H80C78.8954 30 78 30.8954 78 32C78 33.1046 78.8954 34 80 34H83.7143C84.9767 34 86 35.0233 86 36.2857V40C86 41.1046 86.8954 42 88 42C89.1046 42 90 41.1046 90 40V36Z"
      fill="#242424"
    />
    <Path
      d="M30 84C30 87.3137 32.6863 90 36 90H40C41.1046 90 42 89.1046 42 88C42 86.8954 41.1046 86 40 86H36.2857C35.0233 86 34 84.9767 34 83.7143V80C34 78.8954 33.1046 78 32 78C30.8954 78 30 78.8954 30 80V84Z"
      fill="#242424"
    />
    <Path
      d="M90 84C90 87.3137 87.3137 90 84 90H80C78.8954 90 78 89.1046 78 88C78 86.8954 78.8954 86 80 86H83.7143C84.9767 86 86 84.9767 86 83.7143V80C86 78.8954 86.8954 78 88 78C89.1046 78 90 78.8954 90 80V84Z"
      fill="#242424"
    />
    <Rect x={45} y={86} width={30} height={30} rx={4} fill="#F2F2F2" />
    <Path
      d="M53 97C53 93.1402 56.1402 90 60 90C63.8598 90 67 93.1402 67 97C67 100.86 63.8598 104 60 104C56.1402 104 53 100.86 53 97Z"
      fill="#00AB59"
      fillOpacity={0.3}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.0002 97.3828C61.5833 97.3828 62.8713 96.0948 62.8713 94.5117C62.8713 92.9286 61.5833 91.6406 60.0002 91.6406C58.417 91.6406 57.1291 92.9286 57.1291 94.5117C57.1291 96.0948 58.417 97.3828 60.0002 97.3828ZM62.4607 98.2031C63.2823 98.2031 64.0662 98.5564 64.6113 99.1723L64.8057 99.3919L64.6606 99.6469C63.7086 101.32 61.9226 102.359 59.9998 102.359C58.0769 102.359 56.291 101.32 55.3389 99.647L55.1938 99.392L55.3883 99.1723C55.9333 98.5564 56.7172 98.2031 57.5388 98.2031H62.4607Z"
      fill="white"
    />
    <Rect x={49} y={106} width={22} height={2} rx={1} fill="#CCCCCC" />
    <Rect x={51} y={110} width={18} height={2} rx={1} fill="#CCCCCC" />
    <Rect x={45} y={45} width={30} height={30} rx={4} fill="#00AB59" />
    <Path
      d="M53 56C53 52.1402 56.1402 49 60 49C63.8598 49 67 52.1402 67 56C67 59.8598 63.8598 63 60 63C56.1402 63 53 59.8598 53 56Z"
      fill="white"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.0002 56.3828C61.5833 56.3828 62.8713 55.0948 62.8713 53.5117C62.8713 51.9286 61.5833 50.6406 60.0002 50.6406C58.417 50.6406 57.1291 51.9286 57.1291 53.5117C57.1291 55.0948 58.417 56.3828 60.0002 56.3828ZM62.4607 57.2031C63.2823 57.2031 64.0662 57.5564 64.6113 58.1723L64.8057 58.3919L64.6606 58.6469C63.7086 60.32 61.9226 61.3594 59.9998 61.3594C58.0769 61.3594 56.291 60.32 55.3389 58.647L55.1938 58.392L55.3883 58.1723C55.9333 57.5564 56.7172 57.2031 57.5388 57.2031H62.4607Z"
      fill="#00AB59"
    />
    <Rect x={49} y={65} width={22} height={2} rx={1} fill="white" />
    <Rect x={51} y={69} width={18} height={2} rx={1} fill="white" />
    <Rect x={45} y={4} width={30} height={30} rx={4} fill="#F2F2F2" />
    <Path
      d="M53 15C53 11.1402 56.1402 8 60 8C63.8598 8 67 11.1402 67 15C67 18.8598 63.8598 22 60 22C56.1402 22 53 18.8598 53 15Z"
      fill="#00AB59"
      fillOpacity={0.3}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.0002 15.3828C61.5833 15.3828 62.8713 14.0948 62.8713 12.5117C62.8713 10.9286 61.5833 9.64062 60.0002 9.64062C58.417 9.64062 57.1291 10.9286 57.1291 12.5117C57.1291 14.0948 58.417 15.3828 60.0002 15.3828ZM62.4607 16.2031C63.2823 16.2031 64.0662 16.5564 64.6113 17.1723L64.8057 17.3919L64.6606 17.6469C63.7086 19.32 61.9226 20.3594 59.9998 20.3594C58.0769 20.3594 56.291 19.32 55.3389 17.647L55.1938 17.392L55.3883 17.1723C55.9333 16.5564 56.7172 16.2031 57.5388 16.2031H62.4607Z"
      fill="white"
    />
    <Rect x={49} y={24} width={22} height={2} rx={1} fill="#CCCCCC" />
    <Rect x={51} y={28} width={18} height={2} rx={1} fill="#CCCCCC" />
    <Rect
      x={25}
      y={52}
      width={70}
      height={8}
      fill="url(#paint0_linear_1818_2355)"
    />
    <Defs>
      <LinearGradient
        id="paint0_linear_1818_2355"
        x1={60}
        y1={52}
        x2={60}
        y2={60}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#CC013F" />
        <Stop offset={1} stopColor="#CC003F" stopOpacity={0} />
      </LinearGradient>
    </Defs>
  </Svg>
);
export default ContactSyncIcon;
